<template>

  <v-container class="back" fluid fill-height pa-0>

    <v-layout column v-show="show" ref="barWrapper" fill-height ma-0>

      <v-layout justify-space-between style="position: relative" ma-0 pa-0>

        <v-layout justify-start style="position: relative" mt-2 pa-0>

          <div class="active cabinet_hide_button">           
            <div :class="cabinetShow ? 'white cabinet_hide_button_trigger_show' : 'white cabinet_hide_button_trigger_hide'" 
              :data-testid="$options.name + '__div__' + 'hideCabinet'"
              @click="() => hideCabinet()"
            >
              <v-tooltip v-if="cabinetShow" left color="primary">
                <v-icon v-if="cabinetShow" small color="bordergrey" slot="activator">navigate_before</v-icon>
                <span class="white--text">{{ $t('hide cabinet') }}</span>
              </v-tooltip>
              <v-tooltip v-if="!cabinetShow" right color="primary">
                <v-icon v-if="!cabinetShow" small color="bordergrey" slot="activator">navigate_next</v-icon>
                <span class="white--text">{{ $t('show cabinet') }}</span>
              </v-tooltip>
            </div>
          </div>     

          <v-tabs
            light
            v-model="panel"
            height="40px"
            left
            :data-testid="$options.name + '__tabs'"
          >

          <v-tabs-slider color="primary" style="height: 0px; max-width: 0px"></v-tabs-slider>

            <v-tab
              class="font-weight-normal"
              v-for="(place, index) in getPlaces"
              :key="index"
              :data-testid="$options.name + '__' + place + '_tab'"
            >
              <template slot="default">
                <div class="tab_wrapper">
                    <div :class="getPlaces[panel] == place ? 'tab__border' : 'custom-tab'"
                      :data-testid="$options.name + '__' + place + '_tab_template'"
                    >
                      {{ $t(place) }} 
                    </div>
                  </div>
                </template>
            </v-tab>

          </v-tabs>

          <v-layout fill-height justify-end align-center px-2>

            <v-tooltip dark bottom color="secondary">
              <v-btn icon flat dark medium
                v-if="$store.state.auth.user.level <= 1"
                :data-testid="$options.name + '__btn__' + 'edit'"
                @click="() => {$emit('edit')}" 
                class="font-weight-medium" 
                slot="activator" 
              >
                <svg-icon
                  :color="'primary'"
                  :name="'edit'"
                  width="20"
                />
              </v-btn>
              <span>{{ $t('change') }}</span>
            </v-tooltip>

          </v-layout>

        </v-layout>

      </v-layout>

      <v-layout column fill-height pa-2>

        <scroll-area>

          <template slot="body">

            <v-layout v-for="(place, i) in getPlaces" :key="i" v-if="getPlaces[panel] == place" fill-height pt-0 ma-0>

              <v-layout column fill-height v-if="place == 'main' && getFields" justify-start px-2>

                <v-layout shrink v-for="(field, index) in getFields" :key="'main'+index" v-if="field.place == 'main' && field.show == 'true' && field.value && field.name.substring(0, 1) != '$'">

                    <v-flex xs4 v-if="field.value && field.show && field.place == place && field.name != 'coordinates'" shrink px-0 pb-2>

                      <v-checkbox v-if="field.type == 'boolean'" small light readonly color="secondary" v-model="field.value">
                          <template v-slot:label>
                            <span class="black--text">{{$t(field.name)}}</span>
                          </template>
                      </v-checkbox>

                      <v-text-field
                        v-if="field.type != 'boolean'"                       
                        :value="$t(field.name)"
                        light
                        outline
                        flat
                        readonly
                        disabled
                        class="backgrey"
                        hide-details
                        :rows="1"
                        color="white"
                      >
                      </v-text-field>

                    </v-flex>

                    <v-flex xs8 v-if="field.value && field.show && field.place == place && field.name != 'coordinates'" shrink px-0 pb-2>
                    
                      <v-text-field
                        v-if="(field.type != 'timestamp' && field.type != 'boolean')"
                        :data-testid="$options.name + '__text-field__' + field.type + '__' + field.name"
                        :value="field.name == 'type' || field.name == 'condition_type' || field.name == 'location_type'? $t(field.value) : field.value"
                        light
                        outline
                        readonly
                        class="white"
                        hide-details
                        :rows="1"
                        color="accent"
                      >
                      </v-text-field>

                      <v-text-field
                        v-if="field.type == 'timestamp'"
                        :data-testid="$options.name + '__text-field__' + field.type + '__' + field.name"
                        :value="showDate(model.fields[field.name].value)"
                        light
                        outline
                        readonly
                        class="white"
                        hide-details
                        rows="1"
                        color="accent"
                      ></v-text-field>

                    </v-flex>

                </v-layout>

              </v-layout>

              <v-layout column v-if="place == 'template'">

                <v-flex shrink
                  v-for="(field, index) in getFields"
                  :key="'templateField_text'+index"
                  v-if="field.place == 'template' && field.type == 'text' && field.show == 'true' && field.name.substring(0, 1) != '$'"
                  pb-2
                >
                  <v-text-field
                    :value="model.fields[field.name].value"
                    light
                    outline
                    flat
                    readonly
                    class="white"
                    color="primary"
                    background-color="primary"
                    hide-details
                    :label="$t(field.name)"
                    rows="1"
                  ></v-text-field>
                </v-flex>

                <v-flex v-if="place == 'template'" shrink pb-2>

                  <v-layout wrap fill-height>

                    <v-flex xs4 pr-2 pb-2
                      v-for="(field, index) in getFields"
                      :key="'templateField_integer'+index"
                      v-if="field.place == 'template' && field.type == 'integer' && field.show == 'true' && field.name.substring(0, 1) != '$'"
                    >
                      <v-text-field
                        :value="template[field.name]"
                        light
                        auto-grow
                        outline
                        flat
                        readonly
                        class="white"
                        color="primary"
                        background-color="primary"
                        hide-details
                        :label="$t(field.name)"
                        rows="1"
                      ></v-text-field>
                    </v-flex>

                  </v-layout>

                </v-flex>

                <v-flex shrink
                  v-for="(field, index) in getFields"
                  :key="'templateField_boolean'+index"
                  v-if="field.place == 'template' && field.type == 'boolean' && field.show == 'true' && field.name.substring(0, 1) != '$'"
                  pb-2
                >
                  <v-text-field
                    :value="template[field.name] ? $t('yes') : $t('no')"
                    light
                    auto-grow
                    outline
                    flat
                    readonly
                    class="white"
                    color="primary"
                    background-color="primary"
                    hide-details
                    :label="$t(field.name)"
                    rows="1"
                  ></v-text-field>
                </v-flex>

              </v-layout>

              <v-layout column fill-height v-if="place == 'photo/documents'">
                
                <v-flex v-if="getData && getData.latitude">

                  <component
                    :is="'location-map'"
                    :data="getData"
                  />

                </v-flex>

                <v-flex v-if="getData && !getData.latitude">

                  <v-layout column fill-height>
                    
                    <file-image
                      ref="file-image-component"
                      :image="getPlan"
                    />

                  </v-layout>

                </v-flex>

              </v-layout>

                <v-layout fill-height v-if="place == 'composition'" justify-start>
                  <equipment-table
                    :data="getData"
                    :devices="getDevices"
                    @select="(payload) => onDeviceSelect(payload)"
                  />
                </v-layout>

                <v-layout column fill-height v-if="place == 'service'">

                  <cabinet-service-table
                    :data="getData"
                    :devices="getDevices"
                    :closedUnits="closedUnits"
                  />

                </v-layout>
                
                <v-layout column fill-height v-if="place == 'events'">

                  <events-table
                    :data="getData"
                    :devices="getDevices"
                    @device=""
                    @organization=""
                  />

                </v-layout>

              <v-layout column fill-height v-if="place == 'photo/documents'">

                <file-list
                  :files="getFiles"
                  :data="getCabinet"
                  @upload="(payload) => onFileAdd(payload)"
                  @edit="onFileEdit"
                  @delete="(payload) => onFileDelete(payload)"
                />

              </v-layout>

            </v-layout>

          </template>

        </scroll-area>

      </v-layout>

    </v-layout>

    <v-dialog max-width="50%" 
      v-if="dialog.upload.show"
      v-model="dialog.upload.show" 
      :data-testid="$options.name + '__dialog-form-file-import'"
      >
        <form-file-import
          :newFiles="dialog.upload.files"
          :files="getFiles"
          :activeObj="getCabinet"
          @close="onFileImportClose()"
          @upload="(payload) => onFileUpload(payload)"
          @update="() => setup()"
          @delete="(payload) => onFileDelete(payload)"
        />
    </v-dialog>

  </v-container>
</template>

<script lang="ts">
import Vue from 'vue'
import ScrollArea from '@/nms/components/partials/scrollarea.vue'
import svgIcon from '@/nms/components/media/svg/static/svg-icon.vue'
import fileList from '@/nms/components/partials/file-list.vue'
import FormFileImport from '@/nms/pages/forms/form-file-import.vue'
import fileImage from '@/nms/components/partials/file-image.vue'
import cabinetServiceTable from '@/nms/pages/cabinet/cabinet-service-table.vue'
import EquipmentTable from '@/nms/pages/location/table/equipment-table.vue'
import EventsTable from '@/nms/pages/events/events-table.vue'
import LocationMap from '@/nms/components/map/map.vue'

// Типы
interface CabinetData {
  $id?: string
  id?: string
  name?: string
  cls?: string
  template?: string
  [key: string]: any
}

interface FileItem {
  id?: string
  data?: {
    description?: string
  }
  [key: string]: any
}

interface ModelData {
  fields: Record<string, any>
  items: Record<string, any>
  obj: Record<string, any>
  image: any | null
}

interface DialogState {
  upload: {
    files: any[]
    show: boolean
  }
}

interface BarState {
  device: { open: boolean }
}

interface TemplateMap {
  [key: string]: any
}

interface MetaData {
  [key: string]: any
}

interface CmdbQueryResponse {
  $id?: string
  namePath?: string
  links?: any[]
  refs?: any[]
  [key: string]: any
}

export default Vue.extend({
  name: 'CABINET_SHOW',

  components: {
    ScrollArea,
    svgIcon,
    fileList,
    FormFileImport,
    fileImage,
    cabinetServiceTable,
    EquipmentTable,
    EventsTable,
    LocationMap
  },

  props: {
    cabinet: {
      type: Object as () => CabinetData,
      default: () => ({})
    },
    closedUnits: {
      type: Array as () => any[],
      default: () => []
    },
  },

  data(): {
    show: boolean
    cabinetShow: boolean
    obj: CmdbQueryResponse | null
    bar: BarState
    panel: number
    template: any
    templates: TemplateMap
    meta: MetaData
    model: ModelData
    files: FileItem[]
    dialog: DialogState
  } {
    return {
      show: false,
      cabinetShow: true,
      obj: null,
      bar: {
        device: { open: false },
      },
      panel: 0,
      template: {},
      templates: {},
      meta: {},
      model: {
        fields: {},
        items: {},
        obj: {},
        image: null,
      },
      files: [],
      dialog: {
        upload: {
          files: [],
          show: false
        }
      },
    }
  },

  computed: {
    getCabinet(): CabinetData {
      return this.cabinet
    },

    getTemplate(): any {
      return this.template
    },

    getData(): any {
      const store = this.$store.state as any
      return store.devices.treeActive[0]
    },

    getDevices(): any[] {
      const store = this.$store.state as any
      return store.devices.devices
    },

    getFields(): Record<string, any> {
      return this.model.fields
    },

    getFiles(): FileItem[] {
      return this.files.length
        ? this.files.filter(file => {
            const description = file.data?.description
            return description && description.split('.').shift() !== 'image_$'
          })
        : []
    },

    getPlan(): FileItem[] {
      return this.files.filter(file => {
        const description = file.data?.description
        return description && description.split('.').shift() === 'image_$'
      })
    },

    getPlaces(): string[] {
      const store = this.$store.getters
      const places = store.getUI?.events_journal
        ? store.getPlaces.show.cabinet
        : store.getPlaces.show.cabinet.filter((place: string) => place !== 'events')
      return places || []
    },
  },

  watch: {
    '$store.state.file.upload.counter': {
      handler(): void {
        this.loadFiles()
      },
      deep: true
    },
    '$store.state.devices.activeDevice': {
      handler(newVal: { $id?: string } | null): void {
        const isOpen = !!(newVal?.$id)
        this.$set(this.bar.device, 'open', isOpen)
      },
      deep: true
    },
    cabinet: {
      handler(newVal: CabinetData): void {
        if (!newVal) return
        this.setup('WATCH cabinet')
      },
      deep: true
    },
  },

  created(): void {
    this.setup()
  },

  mounted(): void {
    this.show = true
  },

  methods: {
    setup(caller?: string): void {
      this.$set(this.dialog.upload, 'show', false)
      this.loadMeta()
      this.loadTemplates()
      this.loadFiles()
    },

    async loadMeta(): Promise<void> {
      try {
        this.setLoader('loadMeta', true)

        const query = {
          id: [this.cabinet.$id],
          data: {
            namePath: true,
            links: { flatten: false },
            refs: true,
          }
        }

        const obj = await this.$bridge.cmdbQuery(query) as CmdbQueryResponse[]
        this.obj = obj?.[0] || null
        this.meta = await this.obj?.meta() || {}

        if (this.meta) {
          this.model = await this.$prepareMeta(this.meta, this.$options.name)
        }
        await this.prepareData()
        this.setLoader('loadMeta', false)
      } catch (error) {
        this.setLoader('loadMeta', false)
        console.error('CATCH', this.$options.name, 'loadMeta', 'SMTH WRONG', error)
      }
    },

    async prepareData(): Promise<void> {
      try {
        this.setLoader('prepareData', true)
        const model = await this.$prepareData(this.model, this.obj, this.meta)
        if (model) {
          console.log(this.$options.name, 'prepareData', 'model', model)
          this.model = model
        }
        this.setLoader('prepareData', false)
      } catch (error) {
        this.setLoader('prepareData', false)
        console.error('CATCH', this.$options.name, 'prepareData', 'SMTH WRONG', error)
      }
    },

    async loadTemplates(): Promise<void> {
      try {
        this.setLoader('loadTemplates', true)
        const entityTemplates = await this.$bridge.getTemplates('cabinet') as any[]

        if (entityTemplates) {
          entityTemplates.forEach(template => {
            this.$set(this.templates, template.id, template)
          })
          this.template = this.templates[this.cabinet.template || '']
          this.setLoader('loadTemplates', false)
        } else {
          console.log(this.$options.name, 'loadTemplate', 'entity_templates', 'SMTH WRONG', entityTemplates)
          this.setLoader('loadTemplates', false)
        }
      } catch (err) {
        console.error('CATCH', 'loadTemplates', 'entity_templates', err)
        this.setLoader('loadTemplates', false)
      }
    },

    async loadFiles(): Promise<void> {
      try {
        this.setLoader('loadFiles', true)
        this.files = await this.$loadFiles(this.getCabinet.$id) as FileItem[]
        this.setLoader('loadFiles', false)
      } catch (err) {
        console.error('CATCH', this.$options.name, 'loadFiles', err)
        this.setLoader('loadFiles', false)
      }
    },

    async onDeviceSelect(payload: string): Promise<void> {
      try {
        this.setLoader('onDeviceSelect', true)
        const query = {
          id: [payload],
          data: { links: { flatten: false } }
        }
        const device = await this.$bridge.cmdbQuery(query) as CmdbQueryResponse[]
        this.setLoader('onDeviceSelect', false)
        await this.$store.dispatch('activeDevice', device?.[0])
      } catch (err) {
        console.error('CATCH', this.$options.name, 'onDeviceSelect', err)
        this.setLoader('onDeviceSelect', false)
      }
    },

    onFileAdd(payload: any): void {
      Object.keys(payload).forEach(index => {
        this.dialog.upload.files.push(payload[index])
      })
      this.$set(this.dialog.upload, 'show', true)
    },

    onFileUpload(payload: any[]): void {
      if (!payload) return
      payload.forEach(file => {
        this.files.push(file)
      })
      this.$set(this.dialog.upload, 'show', false)
    },

    onFileEdit(): void {
      if (!this.files.length) return
      this.$set(this.dialog.upload, 'show', true)
    },

    onFileDelete(id: string): void {
      try {
        this.setLoader('onFileDelete', true)
        this.dialog.upload.files.forEach((file, index) => {
          if (file.id === id) {
            this.dialog.upload.files.splice(index, 1)
          }
        })
        this.$bridge.deleteDocument(id)
        this.setLoader('onFileDelete', false)
        this.loadFiles()
      } catch (err) {
        console.error('CATCH', this.$options.name, 'loadFiles', err)
        this.setLoader('onFileDelete', false)
      }
    },

    onFileImportClose(): void {
      this.$set(this.dialog.upload, 'show', false)
      this.$set(this.dialog.upload, 'files', [])
    },

    setLoader(name: string, status: boolean): void {
      this.$store.dispatch('setLoader', {
        key: name,
        value: status
      })
    },

    showDate(date: Date): string {
      const adjustedDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString()
      return adjustedDate.substring(0, 10).split('-').reverse().join('.')
    },

    hideCabinet(): void {
      this.cabinetShow = !this.cabinetShow
      this.$emit('showCabinet', this.cabinetShow)
    },
  },
})
</script>

<style scoped>

.cabinet_hide_button {
  position: relative;
  height: 40px;
  width: 40px;
  margin-right: 4px;
  margin-left: 12px;
  border: solid 1px #9F9F9F !important;
  border-radius: 2px;
}

.cabinet_hide_button_trigger_hide {
  position: absolute;
  height: 38px;
  width: 36px;
  border-left: solid 1px #9F9F9F !important;
  border-right: solid 1px #9F9F9F !important;
  padding-top: 8px;
  padding-left: 10px;
  left: 4px;
  border-radius: 2px;
}

.cabinet_hide_button_trigger_show {
  position: absolute;
  height: 38px;
  width: 26px;
  border-left: solid 1px #9F9F9F !important;
  border-right: solid 1px #9F9F9F !important;
  padding-top: 8px;
  padding-left: 4px;
  left: 14px;
  border-radius: 2px;
}

/* .tabs__border {
  border-bottom: solid 1px #9F9F9F !important;
}

.tab__border {
    border-left: solid 1px #9F9F9F !important;
    border-right: solid 1px #9F9F9F !important;
    border-top: solid 10px #CDEBF9 !important;
    border-bottom: solid 8px #FFFFFF !important;
    padding: 4px 12px;
    cursor: pointer;
}

.custom-tab {
  border-left: solid 1px #9F9F9F !important;
  border-right: solid 1px #9F9F9F !important;
  border-top: solid 10px #FFFFFF !important;
  border-bottom: solid 8px #FFFFFF !important;
  padding: 4px 12px;
  cursor: pointer;
} */
</style>
